export * from "./staticData";
